import React from "react";
import styles from "./AboutSocietalMission.module.css";
import Image from "next/image";

interface TitleDescription {
  id: number;
  title: string;
  description: string;
}

interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}

interface CardWithImage {
  id: number;
  title_description: TitleDescription;
  images: Image[];
}

interface CampusImage {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}

interface SocietalMissionData {
  id: number;
  title_description: TitleDescription;
  card_with_image: CardWithImage[];
  campus_image: CampusImage;
}

interface Props {
  data: SocietalMissionData;
  page?: string;
}

const AboutSocietalMission: React.FC<Props> = ({ data, page }) => {
  const { title_description, card_with_image, campus_image } = data;
  return (
    <div
      className={`${styles.aboutTransformative} ${
        page === "alumni" ? styles.alumniPage : ""
      }`}
    >
      <div className="container">
        <div className={styles.TransformativeLearning}>
          <h2>{title_description?.title}</h2>
          <p>{title_description?.description}</p>

          {/* Desktop View */}
          <div
            className={`row align-center justify-content-center ${
              card_with_image && card_with_image.length > 3
                ? styles.multiRowCards
                : ""
            }`}
          >
            {card_with_image?.map((programme, index) => (
              <div
                key={programme.id}
                className={`col-md-4 col-sm-4 ${styles.programBox} ${
                  index >= 3 ? styles.bottomRowCard : ""
                }`}
              >
                <div className={styles.card}>
                  <div className={styles.counterBox}>
                    <h4>{programme?.title_description?.title}</h4>
                    <Image
                      src={programme?.images[0]?.url}
                      alt={programme?.images[0]?.alternativeText}
                      title={programme?.images[0]?.alternativeText}
                      width={44}
                      height={44}
                      style={{
                        width: 44,
                        height: 44,
                      }}
                    />
                  </div>
                  <p>{programme?.title_description?.description}</p>
                </div>
              </div>
            ))}
          </div>

          {campus_image?.url && (
            <div className={styles.societalBanner}>
              <Image
                src={campus_image?.url}
                alt={campus_image?.alternativeText}
                title={campus_image?.alternativeText}
                width={1200}
                height={370}
                sizes="100vw"
                style={{
                  width: "100%",
                  height: "370px",
                  objectFit: "cover",
                  aspectRatio: "1200/370",
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutSocietalMission;
